import { render, staticRenderFns } from "./BlueBtn.vue?vue&type=template&id=2b66b90c&scoped=true"
import script from "./BlueBtn.vue?vue&type=script&lang=ts&setup=true"
export * from "./BlueBtn.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./BlueBtn.vue?vue&type=style&index=0&id=2b66b90c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b66b90c",
  null
  
)

export default component.exports